import { Box, styled } from "@mui/material";


const StyledCalendar = styled(Box)(({ theme }) => ({

    '.react-calendar__tile': {
        margin: '10px 0',
        padding: '10px',
        fontSize: '14px',
        '&:hover': {
            background: 'rgb(99, 226, 198)'
        },
        '&:disabled': {
            backgroundColor: 'transparent !important',
            color: '#bdbdbd'
        }
    },
    '.react-calendar__tile--now': {
        background: 'rgba(99, 226, 198,0.5) !important',
        '&:hover': {
            background: 'rgb(99, 226, 198) !important'
        }
    },
    '.mycal': {
        height: '100%',
        width: '100%',
        margin: '0 auto',
        padding: '20px',
        minHeight: '420px',
        borderTopLeftRadius: '20px',
        borderBottomLeftRadius: '20px',
        backgroundColor: 'rgb(66, 91, 118)',
        [theme.breakpoints.down('md')]:{
            borderBottomLeftRadius: '0',
            borderTopRightRadius: '20px',

        }

    },

    '.content': {
        color: 'white',
        borderRadius: '50px',
        width: 'fit-content'
    },

    /* Change the year color */
    '.react-calendar__navigation__label ': {
        color: 'white',
        backgroundColor: 'transparent !important',

        '&:hover': {
            backgroundColor: 'transparent !important'
        }
    },

    /* Change the arrows color */
    '.react-calendar__navigation__arrow ': {
        color: 'white',
        backgroundColor: 'transparent !important',
        '&:hover': {
            backgroundColor: 'transparent !important'
        },

    },

    /* Change the color of week days */
    '.react-calendar__month-view__weekdays__weekday abbr ': {
        color: 'white',
        textDecoration: 'none'
    },

}))



export {
    StyledCalendar,

}